export default () => ({
  scrollToDocumentsTab(e) {
    e.preventDefault();
    const documentsTabButtons = document.querySelectorAll('button[data-tabitem-id="tabDownloads"]');
    documentsTabButtons.forEach((documentsTabButton) => {
      if (documentsTabButton.offsetParent === null) {
        return;
      }

      // click on visible tab button
      documentsTabButton.click();
      documentsTabButton.scrollIntoView({behavior: 'smooth'});
    });
  }
})
